import React from 'react';
import {Route} from 'react-router-dom';
import AsyncTerms from './async';
import DefaultBusinessLayout from '../../../../../components/layout/DefaultBusinessLayout';

export default (
  <Route
    key="/business/shopify/privacy"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Shopify Privacy',
            item: '/business/shopify/privacy',
          },
        ]}
      />
    }
  >
    <Route path="business/shopify/privacy" element={<AsyncTerms />} />
  </Route>
);
